import React from 'react';
import AuthService from '../../services/AuthService';
import ConsumptionIcon from '../Icons/ConsumptionIcon';

const getUrl = (currentLanguage, formatedNumber) => {
    const token = AuthService.getToken();

    const language = currentLanguage === 'fr_FR' ? 'fr' : 'en';

    const number = formatedNumber.replace(/\-/g, '');

    return `https://www.annatel.co.il/balance/${language}/consumption.php?number=${number}&token=${token}`;
}

const ViewBalancesLink = ({ balance, translate, currentLanguage, formatedNumber }) => {
    if (!balance) {
        return (
            <React.Fragment></React.Fragment>
        )
    }

    const url = getUrl(currentLanguage, formatedNumber)
    return (
        <li key="showBalances" className="list-action-item">
            <ConsumptionIcon />
            <a href={url} target="_blank" className="btn btn-action nav-link-text">
                <span className="nav-link-text">{translate('balance')}</span>
            </a>
        </li>
    )
}

export default ViewBalancesLink;


// WEBPACK FOOTER //
// ./src/components/MyServices/ViewBalancesLink.js